import { apiGateway } from "@/shared/apiGateway";

const getDashboard = (context, { clientId }) => {
  var url = "api/dashboard/";
  if (clientId !== "0") {
    url = url + "?clientId=" + clientId;
  }
  return apiGateway
    .apiGatewayGET(url)
    .then(data => {
      context.commit(
        "REPORT_SETTIMEDDEFECTSTATUSESCHARTDATA",
        data.dashboardCharts.timedDefectStatus
      );
      context.commit(
        "REPORT_SETUNTIMEDDEFECTSTATUSESCHARTDATA",
        data.dashboardCharts.untimedDefectStatus
      );
      context.commit(
        "REPORT_SETSAFEDSTATUSESCHARTDATA",
        data.dashboardCharts.safedStatus
      );
      context.commit("set_quote_metric", data.metrics.quoteMetric);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Dashboard"], {
        root: true
      });
    });
};

const getContractorStatInspItemReport = (context, clientId) => {
  apiGateway
    .apiGatewayBLOB(
      "api/reports/stat-insps-by-contractor-details?clientId=" + clientId
    )
    .catch(error => {
      console.error(error);
      context.dispatch(
        "SHOW_ERROR_ALERT",
        ["Error getting Stat. Insps. for contractor report"],
        { root: true }
      );
    });
};

const getActivePlantReport = (context, { clientId }) => {
  var url = "api/reports/active-plant";
  if (clientId !== "0") {
    url = url + "?clientId=" + clientId;
  }
  apiGateway.apiGatewayBLOB(url).catch(error => {
    console.error(error);
    context.dispatch(
      "SHOW_ERROR_ALERT",
      ["Error getting Active Plant Report"],
      { root: true }
    );
  });
};

export default {
  getActivePlantReport,
  getContractorStatInspItemReport,
  getDashboard
};
